export const buildVersion = "de8b79e8e895dee305f433f5839e7d5480526f14";
